export enum CashAppFormInputNames {
  CashAppAddress = 'cashappValue',
}
